import React from 'react';
import './TodoItem.css';

const TodoItem = ({ 
  todo, 
  onDelete, 
  onEdit, 
  onComplete 
}) => {
  return (
    <div className={`todo-item ${todo.completed ? 'completed' : ''}`}>
      <input 
        type="checkbox" 
        checked={todo.completed} 
        onChange={onComplete} 
        className="checkbox"
      />
      <span onClick={onComplete} className="todo-text">{todo.text}</span>
      <button onClick={onEdit} className="action-button">Edit</button>
      <button onClick={onDelete} className="action-button">Delete</button>
    </div>
  );
};

export default TodoItem;
